import { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiInstance from "../../../apiInstance";
import PopupModal from "../../Popups/PopupModal";
import TicketDetails from "./TicketDetails";
import AddReply from "./AddReply";

const DetailsPage = () => {
    const { ticketId } = useParams();
    const [ticketDetails, setTicketDetails] = useState({});
    const [error, setError] = useState("");
    const popupRef = useRef();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchTicketDetails = async () => {
            apiInstance
                .get(`/devadmin/support-ticket/${ticketId}`)
                .then((response) => {
                    setTicketDetails(response.data.ticket || {});
                })
                .catch((error) => {
                    console.error("Error fetching data:", error);
                    setError("Failed to load ticket details.");
                });
        };
        fetchTicketDetails();
    }, [ticketId]);

    return (
        <div className="mjsdev-dtl-page">
            <div className="mjsdev-dtl-header">
                <button
                    className="mjsdev-dtl-back-btn mjs-btn"
                    onClick={() => navigate("/devadmin/support-tickets")}
                >
                    All Tickets
                </button>
                <div>
                    <span
                        className="mjs-badge"
                        style={{
                            backgroundColor:
                                ticketDetails.status === "open"
                                    ? "#1565c0"
                                    : ticketDetails.status === "in_progress"
                                    ? "#f9a825"
                                    : ticketDetails.status === "resolved"
                                    ? "#2e7d32"
                                    : "#c62828",
                        }}
                    >
                        {ticketDetails.status?.replace("_", " ")}
                    </span>
                </div>
            </div>

            <div className="mjs-error">{error}</div>

            <TicketDetails ticketDetails={ticketDetails} />

            <AddReply
                ticketDetails={ticketDetails}
                updateTicket={setTicketDetails}
            />

            <PopupModal ref={popupRef} />
        </div>
    );
};

export default DetailsPage;
